import {
  BuyerAccessLevel,
  OperatorAccessLevel,
  SupplierAccessLevel,
} from '@ps/core-models';

const BUYER_ACCESS_LEVELS: readonly BuyerAccessLevel[] = [
  'none',
  'limited',
  'full',
  'admin',
  'superAdmin',
  'limitedDraft',
  'multiBuyer',
  'masterMultiBuyer',
];

const OPERATOR_ACCESS_LEVELS: readonly OperatorAccessLevel[] = [
  'none',
  'limited',
  'full',
  'admin',
  'support',
  'serviceOperator',
];

const SUPPLIER_ACCESS_LEVELS: readonly SupplierAccessLevel[] = [
  'none',
  'limited',
  'full',
  'admin',
];

export const toBuyerAccessLevel = (value: string): BuyerAccessLevel =>
  BUYER_ACCESS_LEVELS.find((level) => level === value) ?? 'none';

export const toOperatorAccessLevel = (value: string): OperatorAccessLevel =>
  OPERATOR_ACCESS_LEVELS.find((level) => level === value) ?? 'none';

export const toSupplierAccessLevel = (value: string): SupplierAccessLevel =>
  SUPPLIER_ACCESS_LEVELS.find((level) => level === value) ?? 'none';
